import React from 'react';
import { decl, bool2string } from '@yandex-lego/i-bem-react';

import _header2__main from "./__main/header2__main.react.js";

var HeaderMain = _header2__main.applyDecls();

import "./__main/header2__main.css";
import _header2__left from "./__left/header2__left.react.js";

var HeaderLeft = _header2__left.applyDecls();

import "./__left/header2__left.css";
import _header2__right from "./__right/header2__right.react.js";

var HeaderRight = _header2__right.applyDecls();

import "./__right/header2__right.css";
import _header2__gap from "./__gap/header2__gap.react.js";

var HeaderGap = _header2__gap.applyDecls();

import "./__gap/header2__gap.css";
import _header2__logo from "./__logo/header2__logo.react.js";

var HeaderLogo = _header2__logo.applyDecls();

import "./__logo/header2__logo.css";
import "./__logo/_size/header2__logo_size_m.css";
import _header2__paranja from "./__paranja/header2__paranja.react.js";

var HeaderParanja = _header2__paranja.applyDecls();

import "./__paranja/header2__paranja.css";
import _header2__under from "./__under/header2__under.react.js";

var HeaderUnder = _header2__under.applyDecls();

import "./__under/header2__under.css";
import _header2__progress from "./__progress/header2__progress.react.js";

var HeaderProgress = _header2__progress.applyDecls();

import "./__progress/header2__progress.css";


export default decl({
    block: 'header2',
    mods: function mods(_ref) {
        var fixed = _ref.fixed,
            panels = _ref.panels,
            border = _ref.border;

        return {
            fixed: bool2string(!!fixed),
            panels: bool2string(!!panels),
            border: border
        };
    },
    content: function content(_ref2) {
        var logo = _ref2.logo,
            left = _ref2.left,
            right = _ref2.right,
            children = _ref2.children;

        return children ? children : React.createElement(
            HeaderMain,
            { key: 'main' },
            logo,
            React.createElement(
                HeaderLeft,
                null,
                left
            ),
            React.createElement(
                HeaderRight,
                null,
                right
            )
        );
    }
}, {
    Main: HeaderMain,
    Left: HeaderLeft,
    Right: HeaderRight,
    Logo: HeaderLogo,
    Paranja: HeaderParanja,
    Under: HeaderUnder,
    Gap: HeaderGap,
    Progress: HeaderProgress
});